import { Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { OverviewSectionContact } from "./OverViewSection";

const TabSectionsContact: React.FC<any> = React.memo((props) => {
  const { control } = useForm();
  const tabsData: any[] = [
    { label: "OverView", content: <OverviewSectionContact /> },
    { label: "Activities", content: "" },
  ];
  return (
    <Grid sx={{ border: "1px solid #ddd", borderRadius: 1, }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSTabs id="adasd" justifyTabs="flex-start" control={control} name="tabs" tabs={tabsData} />
        </Grid>
      </Grid>
    </Grid>
  );
});

export default TabSectionsContact;
